import React, { Fragment } from 'react'
import { CssBaseline, Box, withStyles } from '@material-ui/core'
import Hidden from '@material-ui/core/Hidden'
import { usePageId } from '@seasonedsoftware/utils'

import PageTitle from 'core/PageTitle'
import AppBar from 'ui/header/AppBar'
import Footer from 'ui/NewFooter'
import useCurrentUser from 'auth/useCurrentUser'
import useSendUserMetadataToClarity from 'utils/useSendUserMetadataToClarity'

const Layout = props => {
  const { classes, title, location, children, layoutStyle = {} } = props
  const id = usePageId(location)
  const [{ currentUser }] = useCurrentUser()
  useSendUserMetadataToClarity(currentUser)

  const showSidebar = currentUser

  const [amazonPathname] = location.pathname.match(/amazon-subscribe/) || []

  return (
    <Fragment>
      <Box
        css={{
          minHeight: 'calc(100vh - 64px)',
          width: '100%',
        }}
      >
        <AppBar location={location} showSidebar={showSidebar} />
        <Box
          component="section"
          className={classes.contentContainer}
          style={{
            ...layoutStyle,
            ...(showSidebar ? {} : { paddingLeft: 0 }),
          }}
          id={id}
        >
          <CssBaseline />
          {title && <PageTitle>{title}</PageTitle>}
          {children}
        </Box>
      </Box>
      <Footer oldVersion />

      {amazonPathname === 'amazon-subscribe' && (
        <React.Fragment>
          <Hidden only={['xs', 'md', 'lg', 'xl']}>
            <div style={{ height: 258 }}></div>
          </Hidden>
          <Hidden smUp>
            <div style={{ height: 236 }}></div>
          </Hidden>
        </React.Fragment>
      )}
    </Fragment>
  )
}

const styles = theme => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(12, 0, 6, 13),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
})

export default withStyles(styles)(Layout)
